module.exports = __webpack_public_path__ + "img/erp_case3.8f030b93.png";